// extracted by mini-css-extract-plugin
export default {"passwordButton":"cmp-Password__password__passwordButton cmp-Button__button__root cmp-components__clickable__root","root":"cmp-Password__password__root"};